export class ContentManagementConstants {
    static webContentsWithScript: string[] = [
        '/nxi/disclosure/brokeragedisclosure/exchangeagreements',
        'nxi/disclosure/brokeragedisclosure/exchangeagreements/nasdaqomxterms',
        '/nxi/disclosure/bankcustodydisclosures/exchangeagreements',
        'nxi/disclosure/bankcustodydisclosures/exchangeagreements/nasdaqomxterms',
        '/nxi/disclosure/tradingdisclosure/exchangeagreements',
        'nxi/disclosure/tradingdisclosure/exchangeagreements/nasdaqomxterms'
    ];

    static postLoginUrls: string[] = [
        '/nxi/advisor-home'
    ];
}

export class CMSEvents {
    public static readonly EDIT_COMPONENT: string = 'pershing.assembly.edit.EditComponent';
    public static readonly EDIT_COMPONENT_COMPLETE: string = 'pershing.assembly.edit.EditComponentCompleted';
    public static readonly EDIT_CONTENT_VERSION_UPDATE: string = 'sitebuilder.cms.edit.contentVersion';
    public static readonly PLACE_ONETRUST: string = 'pershing.content.management.placeontrust';
}

export class CustomHeader {
    static propertyMap = new Map([
        [ '55G', new Map([[ 'about_us_login', 'welcome']])],
        [ '3CR', new Map([[ 'cookie_notice', 'cookie_notice_custom'], [ 'privacy_policy', 'privacy_policy_custom']])],
        [ '3Z1', new Map([[ 'cookie_notice', 'cookie_notice_custom'], [ 'privacy_policy', 'privacy_policy_custom']])],
        [ 'BBA', new Map([[ 'cookie_notice', 'cookie_notice_custom'], [ 'privacy_policy', 'privacy_policy_custom']])],
        [ '55G', new Map([[ 'cookie_notice', 'cookie_notice_custom'], [ 'privacy_policy', 'privacy_policy_custom']])],
        [ '5QH', new Map([[ 'site_specific_resources', 'external_links']])],
        [ '56M', new Map([[ 'site_specific_resources', 'external_links']])],
        [ 'NSC', new Map([[ 'site_specific_resources', 'external_links']])],
        [ '41K', new Map([[ 'about_us_login', 'international_brokerage'], [ 'links', 'links_watani']])],
        [ 'H1X', new Map([[ 'contact_us_login', 'need_assistance']])],
        [ 'cpwm', new Map([[ 'contact_us_login', 'need_assistance']])],
        [ 'C01', new Map([[ 'contact_us_login', 'need_assistance'], [ 'cookie_notice', 'cookie_notice_custom'], [ 'privacy_policy', 'privacy_policy_custom']])],
        [ '5DC', new Map([[ 'business_continuity', 'dreyfus_business_continuity']])],
        [ 'XGW', new Map([[ 'custom_contactus', 'customer_contact_us']])],
        [ 'NV6', new Map([[ 'path_to_investing', 'external_links']])],
        ['33L', new Map([[ 'custom_contactus', 'head_quarters']])],
        [ '44A', new Map([[ 'site_specific_resources', 'external_links']])],
        [ 'PEC', new Map([[ 'site_specific_resources', 'external_links']])],
        [ 'netxinvestor', new Map([ [ 'privacy_policy', 'privacy_policy_custom']])],
		[ '028', new Map([[ 'netx_investor_mobile_solutions', 'mobile_solution'], [ 'netx_investor_mobile_solutions_about', 'mobile_solution']])],
		[ 'TM9', new Map([[ 'contact_us_login', 'invertis_contact_us'], [ 'custom_contactus', 'invertis_contact_us'],
						[ 'invertis_security_recommendations', 'invertis_security_recommendations']])],
        [ 'VCS', new Map([[ 'custom_contactus', 'victory_contact_us'],[ 'contact_us_login', 'victory_contact_us']])]

    ]);
}
